export const rowMarginParameters = {
  marginTopFirstRow: 8,
  marginTopNOTFirstRow: 0,
};
